import React, { useEffect, useRef, useState } from 'react'
import downloadIcon from '../../assets/images/downloadIcon.svg'
import expandIcon from '../../assets/images/Expand-arrow.svg'
import arrowIcon from '../../assets/images/whiteArrowIcon.svg'
import foundryIcon from '../../assets/images/Foundry logo.svg'
import editPrompt from '../../assets/images/edit_prompt.svg'
import placeholderImage from '../../assets/images/Carousel1.png'
import infoIcon from '../../assets/images/InfoIcon.svg'
import infoIconWhite from '../../assets/images/whiteInfo.svg'
import disclaimers from '../../assets/images/dangerSvg.svg'
import disclaimersWhite from '../../assets/images/dangerSvgWhit.svg'
import likeIcon from '../../assets/images/like_icon.svg'
import white_likeIcon from '../../assets/images/white_like_icon.svg'
import dislikeIcon from '../../assets/images/dislike_icon.svg'




import emoji0 from '../../assets/images/noRating.svg'
import emoji1 from '../../assets/images/emoji-1.svg'
import emoji2 from '../../assets/images/emoji-2.svg'
import emoji3 from '../../assets/images/emoji-3.svg'
import emoji4 from '../../assets/images/emoji-4.svg'
import emoji5 from '../../assets/images/emoji-5.svg'
import { AsyncImage } from 'loadable-image'
// import { Blur } from 'transitions-kit'


import { Tooltip as ReactTooltip } from "react-tooltip";
import ModalsWrapper from '../Wrappers/ModalsWrapper'
import { downloadImage } from '../../utils/helpers'
import EditPrompt from './EditPrompt'
import SelectFont from './SelectFont'
import { useDispatch, useSelector } from 'react-redux'
import { setDownloadImageModal, setIsOpenShareFeedbackModal, setIsOpenTermsAndConditionsModal, setIsOpenViewDetailsModal, setSingleImageData } from '../../redux/imageModalSlice'
import ReactGA from "react-ga4";
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useNavigate } from 'react-router-dom'
import axiosTokenInstance from '../../services/axiosInstance'
import Button from '../buttons/Button'
import { updateGeneratedImageFeedback } from '../../redux/createImageSlice'
import { updateFeedback } from '../../redux/pastCreateionsSlice'
import { showToast } from '../../redux/toasterSlice'

const Tooltip = ({ id, place, content }) => (
    <ReactTooltip
        id={id}
        place={place}
        content={content}
        style={{ backgroundColor: '#1E242C', borderRadius: '8px', fontSize: '13px', lineHeight: '16px', zIndex: '9999' }}
    />
);

const ImageModal = ({ index, imageData, generateFontVisualsHandler, setImageModalWidth }) => {
    const dispatch = useDispatch();
    const location = window.location;
    const guid = localStorage.getItem("guid")

    const disclaimerTimeoutRef = useRef(null);
    const disclaimerRef = useRef(null);
    const iconRef = useRef(null);
    const divRef = useRef(null);

    const { isImageLoading } = useSelector((state) => state.createImage);

    const [openExpandImage, setOpenExpandImage] = useState(false)
    const [openEditPrompt, setOpenEditPrompt] = useState(false)
    const [openEditFontModal, setOpenEditFontModal] = useState(false);
    const [imageInputValue, setImageInputValue] = useState('');
    const [fontInputValue, setFontInputValue] = useState('');
    const [modalPosition, setModalPosition] = useState(null);
    const [imageSrc, setImageSrc] = useState('');
    const [expandImageSrc, setExpandImageSrc] = useState('');
    const [imageLoaded, setImageLoaded] = useState(false);
    const [showDisclaimer, setShowDisclaimer] = useState(false);

    useEffect(() => {
        const loadImage = () => {
            let src
            if (location.pathname === "/generate-image") {
                src = `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.images}`;
            } else {
                src = imageData?.thumbnailImage ?
                    `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.thumbnailImage}`
                    : `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.images}`;
            }
            setImageSrc(src);
            setExpandImageSrc(`${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.images}`)
        };

        loadImage();


        const interval = setInterval(() => {
            if (!imageLoaded) {
                loadImage();
            } else {
                clearInterval(interval);
            }
        }, 500);

        return () => clearInterval(interval);
    }, [imageLoaded, imageData]);

    const handleImageError = () => {
        setImageSrc("")
        setTimeout(() => {
            const src = imageData?.images?.includes("dump")
                ? `${process.env.REACT_APP_AWS_BUCKET_URL_OTHER}/${imageData?.images}`
                : `${process.env.REACT_APP_AWS_BUCKET_URL}/${imageData.modelName}/specific_need/${imageData.md5hash}/${imageData.images}`;
            setImageSrc(src);
        }, 1000);
    };

    const handleImageLoad = (event) => {
        if (event.target.naturalWidth === 0 || event.target.naturalHeight === 0) {
            handleImageError();
        }
    };

    const handleEditPromptClick = (e) => {
        const rect = e.target.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const modalWidth = 542;
        const offset = 32;

        const rightPosition = viewportWidth - rect.right + offset;
        const leftPosition = rect.left - modalWidth - offset;

        rect.right + modalWidth > viewportWidth
            ? setModalPosition(`-left-[537px]`)
            : setModalPosition("left-12");
        setOpenEditPrompt(true)
    };

    const emojiList = [emoji0, emoji1, emoji2, emoji3, emoji4, emoji5];
    const handleEmojiChange = emojiList[imageData.rating] || emoji0;

    useEffect(() => {
        function handleMouseLeave(event) {
            if (
                disclaimerRef.current &&
                !disclaimerRef.current.contains(event.relatedTarget) &&
                iconRef.current &&
                !iconRef.current.contains(event.relatedTarget)
            ) {
                setShowDisclaimer(false);
            }
        }

        if (showDisclaimer) {
            document.addEventListener('mouseleave', handleMouseLeave);
        }

        return () => {
            document.removeEventListener('mouseleave', handleMouseLeave);
        };
    }, [showDisclaimer]);

    const [disclaimerPosition, setDisclaimerPosition] = useState(null);


    const handleMouseEnter = (e) => {
        if (disclaimerTimeoutRef.current) {
            clearTimeout(disclaimerTimeoutRef.current);
        }
        const rect = e.target.getBoundingClientRect();
        const viewportWidth = window.innerWidth;
        const modalWidth = 384;
        const offset = 32;

        const rightPosition = viewportWidth - rect.right + offset;
        const leftPosition = rect.left - modalWidth - offset;

        if (rect.right + modalWidth > viewportWidth) {
            if (viewportWidth >= 1024 && viewportWidth <= 1045 && rect.right < 800) {
                setDisclaimerPosition("-right-[100px]");
            } else {
                setDisclaimerPosition("right-[50px]");
            }
        } else {
            setDisclaimerPosition(rect.left);
        }
        setShowDisclaimer(true);
    };

    const handleMouseEnterDisclimer = (e) => {
        if (disclaimerTimeoutRef.current) {
            clearTimeout(disclaimerTimeoutRef.current);
        }
        setShowDisclaimer(true);
    };

    const handleMouseLeave = () => {
        disclaimerTimeoutRef.current = setTimeout(() => {
            setShowDisclaimer(false);
        }, 200);
    };

    useEffect(() => {
        const resizeObserver = new ResizeObserver((entries) => {
            if (entries[0]) {
                setImageModalWidth(entries[0].contentRect.width);
            }
        });

        if (divRef.current) {
            resizeObserver.observe(divRef.current);
        }

        return () => resizeObserver.disconnect();
    }, []);

    const handleLikeDislikeIconClick = async (identifier) => {
        const feedbackData = {
            _id: imageData._id,
            rating: identifier === 'like' ? 5 : 1,
        };
        try {
            const response = await axiosTokenInstance.post(`/feedback`, feedbackData);
            if (response.status === 201) {
                dispatch(
                    showToast({
                        message: 'Your feedback has been shared successfully',
                        type: 'success',
                    }),
                );
                dispatch(updateGeneratedImageFeedback({ feedbackData }))
                dispatch(updateFeedback({ promptId: imageData.promptId, feedbackData }));
            }
            ReactGA.gtag('event', 'feedback_submit', {
                action: 'Feedback submitted ',
                label: `Average rating:${feedbackData.rating}`,
                value: feedbackData.rating
            });
        } catch {
            dispatch(
                showToast({
                    message: 'Failed to submit feedback. Try again.',
                    type: 'error',
                }),
            );
        }
    }

    return (
        <div key={index} ref={divRef} className='aspect-[1/1] relative group cursor-pointer'>
            {location.pathname === "/generate-image" ?
                <img src={imageSrc} alt="" onError={handleImageError} onLoad={handleImageLoad} />
                :
                <AsyncImage
                    src={imageSrc}
                    alt={imageSrc}
                    onError={handleImageError}
                    onLoad={handleImageLoad}
                    className='h-full w-full aspect-[1/1] object-cover'
                // Transition={Blur}
                />
            }

            {openEditPrompt && (
                <div className={`absolute z-30 ${modalPosition} -top-8`}>
                    <EditPrompt
                        onClose={() => setOpenEditPrompt(false)}
                        openSelectFontModal={() => setOpenEditFontModal(true)}
                        imageData={imageData}
                        imageInputValue={imageInputValue}
                        setImageInputValue={setImageInputValue}
                        fontInputValue={fontInputValue}
                        setFontInputValue={setFontInputValue}
                    />
                </div>
            )}
            <ModalsWrapper open={openEditFontModal} onClose={() => setOpenEditFontModal(false)} >
                <SelectFont onClose={() => setOpenEditFontModal(false)} imageData={imageData} imageInputValue={imageInputValue} fontInputValue={fontInputValue} />
            </ModalsWrapper>
            <div className='h-full w-full p-[10px] absolute top-0 hidden group-hover:flex flex-col justify-between bg-black/50 transition-all duration-300 ease-in-out'>
                <div onClick={() => {
                    dispatch(setSingleImageData(imageData));
                    dispatch(setIsOpenViewDetailsModal(true))
                    ReactGA.gtag('event', 'click_to_see_more', {
                        action: 'Click to see more',
                        label: 'Click to see more'
                    });
                }}
                    className='text-white w-full absolute flex items-center justify-center h-full  cursor-pointer'
                >
                    Click to see more
                </div>
                <div className=' flex justify-between z-10'>
                    <div></div>
                    <div className='flex gap-[8px]'>
                        <div
                            ref={iconRef}
                            onMouseEnter={handleMouseEnter}
                            onMouseLeave={handleMouseLeave}
                            className={`h-[32px]  w-[32px] flexCenter rounded-[8px] bg-white border-1 border-[#DC5800] ${showDisclaimer && 'border-1 border-[#DC5800] '} `}
                        >
                            <img src={disclaimers} alt="disclimer" className='h-[16px] w-[16px]' />
                        </div>
                        {showDisclaimer &&
                            <div ref={disclaimerRef}
                                onMouseEnter={handleMouseEnterDisclimer}
                                onMouseLeave={handleMouseLeave}
                                className={`shadow-xl w-[384px] bg-white p-[40px] absolute z-20 top-[50px] ${disclaimerPosition} rounded-lg flex flex-col gap-[24px]`}>
                                <h2 className="text-[24px] leading-[32px] text-[#1E242C] font-helveticaText-Medium">Disclaimer</h2>
                                <div className={`flex flex-col gap-[16px]`} >
                                    <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify hyphens-auto' >AI-generated visualizations aim to closely replicate original fonts; however, slight variations may occur.</h5>
                                    <h5 className='text-[13px] leading-[16px] text-[#667488] text-justify' >
                                        Portrait is designed to inspire users by showing how fonts look in visual settings. The main text reflects the chosen font, while smaller text may appear unreadable.
                                        Please refer to our <a href='/terms-and-conditions' target="_blank" rel="noopener noreferrer" className='text-blue-primary '>terms and conditions</a> for more details on image usage guidelines.
                                    </h5>
                                </div>
                            </div>
                        }


                        <div
                            data-tooltip-id={`expand-image-${index}`}
                            onClick={(e) => { e.stopPropagation(); setOpenExpandImage(true) }}
                            className='h-[32px] w-[32px] flexCenter bg-white rounded-[8px]'
                        >
                            <img src={expandIcon} alt="expand icon" className='h-[16px] w-[16px]' />
                        </div>
                    </div>
                    <ModalsWrapper open={openExpandImage} onClose={() => setOpenExpandImage(false)} closeIconColor="white" expandImage={true}>
                        <div>
                            <AsyncImage
                                className='h-[550px] w-[550px] 2xl:h-[700px] 2xl:w-[700px] aspect-auto rounded-[18px] border-[5px] object-cover'
                                src={expandImageSrc}
                                alt=""
                                onError={handleImageError}
                                onLoad={handleImageLoad}
                            // Transition={Blur}
                            />
                        </div>
                    </ModalsWrapper>
                </div>
            </div>


            <div className='absolute top-[10px] left-[10px] z-10 flex gap-[8px] '>
                <div
                    data-tooltip-id={`rate-image-${index}`}
                    data-tooltip-content="Rate image"
                    onClick={() => {imageData.rating !== 5 && handleLikeDislikeIconClick("like")}}
                    className={`h-[32px] w-[32px] ${imageData.rating > 1 ? 'bg-[#1A73E8]' : 'bg-white'}  flexCenter rounded-[8px]`}
                >
                    <img src={imageData.rating > 1 ? white_likeIcon : likeIcon} alt="" />
                </div>
                <div
                    data-tooltip-id={`rate-image-${index}`}
                    data-tooltip-content="Rate image"
                    onClick={() => {imageData.rating !== 1 && handleLikeDislikeIconClick("dislike")}}
                    className={`h-[32px] w-[32px] ${imageData.rating === 1 ? 'bg-[#1A73E8]' : 'bg-white'}  flexCenter rounded-[8px]`}
                >
                    <img src={imageData.rating === 1 ? white_likeIcon : dislikeIcon} alt="" className={`${imageData.rating === 1 && 'rotate-180'}`} />
                </div>
            </div >

            <div className='absolute bottom-[10px] px-[10px] w-full flex items-center  justify-between gap-[4px] '>
                <div className='w-full flex items-center gap-[8px] text-white'>
                    <img src={foundryIcon} alt="foundry icon" className='h-[16px] w-[16px]' />
                    <span>{imageData.fontFamily}</span>
                </div>
                <div className='w-fit flex gap-[8px]'>
                    <a
                        href={`https://enterprise.monotype.com/en/family/${imageData?.fontFamilyUrl}?utm_source=portrait&utm_medium=${imageData?.md5hash}&utm_campaign=${guid}`}
                        onClick={(e) => {
                            e.stopPropagation()
                            ReactGA.gtag('event', 'font_redirect', {
                                action: 'Redirection to Enterprise',
                                label: `https://enterprise.monotype.com/en/family/${imageData?.fontFamilyUrl}`
                            });
                        }
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        className='h-[32px] w-[130px]  flexCenter gap-[8px] bg-blue-primary text-white rounded-[8px]'>
                        <div className='text-[13px]'>Get this font</div>
                        <img src={arrowIcon} alt="arrow icon" className='h-[16px] w-[16px]' />

                    </a>
                </div>
            </div>
            <Tooltip
                id={`rate-image-${index}`}
                place="right"
                content="Rate image"
            />
            {/* <Tooltip
                id={`edit-image-${index}`}
                place="right"
                content="Edit image"
            /> */}
            <Tooltip
                id={`download-image-${index}`}
                place="left"
                content="Download"
            />
            <Tooltip
                id={`expand-image-${index}`}
                place="left"
                content="Expand"
            />
            <Tooltip
                id={`expand-image-${index}`}
                place="left"
                content="Expand"
            />
            <Tooltip
                id={`generate-visual-${index}`}
                place="left"
                content={` ${isImageLoading ? "Generating visual..." : "Generate visual"}`}
            />
            <Tooltip
                id={`get-this-font-${index}`}
                place="left"
                content="Get this font"
            />
        </div >
    )
}

export default ImageModal